var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-circular',{attrs:{"value":_vm.props.value,"color":_vm.progessColor(_vm.props.value),"size":"36","width":"6"}},[_vm._v(" "+_vm._s(_vm.props.value)+"%")])
}
var staticRenderFns = []

export { render, staticRenderFns }